// extracted by mini-css-extract-plugin
module.exports = {"toggler":"DashboardActionsMobile_toggler__htz3K"};